export default __webpack_public_path__ + "static/media/img_blanketBaseBunny_beige_p.b748fba0.jpg";